import { ReactNode, createContext, useContext } from "react";
import { useFilterTerminationType } from "./filter-termination-type.hook";

const FilterTerminationTypeContext = createContext(
  {} as ReturnType<typeof useFilterTerminationType>
);
export function useFilterTerminationTypeContext() {
  return useContext(FilterTerminationTypeContext);
}

interface FilterTerminationTypeProviderProps {
  children: ReactNode;
}
export function FilterTerminationTypeProvider({
  children,
}: FilterTerminationTypeProviderProps) {
  return (
    <FilterTerminationTypeContext.Provider value={useFilterTerminationType()}>
      {children}
    </FilterTerminationTypeContext.Provider>
  );
}